import React from "react";

//Components
import AppMenu from "./ToolBar/AppMenu";

//MUI
import { AppBar, Button, Toolbar, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

const styles = {
  root: {
    flexGrow: 1
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between"
  },
  flex: {
    cursor: "pointer",
    display: "flex"
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20
  }
};

const ToolBar = props => {
  const {
    classes,
    cUID,
    email,
    isAuthenticated,
    loginPending,
    logoutPending,
    // eslint-disable-next-line
    role,
    route,
    routeToHome,
    routeToLogin,
    routeToSignUp,
    signUpPending,
    submitLogout
  } = props;
  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar className={classes.toolbar} color="inherit">
          {/* 
            Menu shows on login
        */}
          {isAuthenticated && !signUpPending && !loginPending ? (
            <AppMenu {...props} />
          ) : null}

          {/* 
              Brand
            */}
          <Typography
            variant="h6"
            color="inherit"
            className={classes.flex}
            onClick={() => routeToHome(isAuthenticated)}>
            <b>TAPA</b> portal
          </Typography>

          {/* 
              Login / Logout button
         */}
          {!isAuthenticated && route === "/login" ? (
            <Button color="inherit" onClick={() => routeToSignUp()}>
              sign up
            </Button>
          ) : !isAuthenticated ? (
            <Button color="inherit" onClick={() => routeToLogin()}>
              Login
            </Button>
          ) : isAuthenticated && !signUpPending && !loginPending ? (
            <Button
              color="inherit"
              onClick={() => submitLogout(cUID, email)}
              disabled={logoutPending}>
              Logout
            </Button>
          ) : (
            <Button
              color="inherit"
              onClick={() => routeToLogin()}
              disabled={loginPending || signUpPending}>
              Login
            </Button>
          )}
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default withStyles(styles)(ToolBar);



// WEBPACK FOOTER //
// ./src/components/ToolBar.js